module.exports = __webpack_public_path__ + "img/web.90d34465.svg";